import { ChangeDetectionStrategy, Component, Signal, computed, input } from '@angular/core';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgIconComponent {
  icon = input.required<string>();

  viewBox: Signal<string> = computed(() => {
    if (this.icon() === 'info') {
      return '0 0 32 32';
    }

    if (this.icon() === 'info-circle') {
      return '0 0 24 28';
    }

    if (this.icon() === 'exclamation-triangle') {
      return '0 0 28 24';
    }

    //if not menu set viewbox model default value, anglar provide angular svg component, so we can implement that in the future
    if (this.icon().indexOf('menu') === -1) {
      return '0 0 24 24';
    }

    return undefined;
  });

  xlink_href: Signal<string> = computed(() => `/css/svg/icons.svg#${this.icon()}`);
}
